<template>
  <v-sheet outlined rounded="lg" class="pa-4">
    <div class="d-flex justify-space-between align-center mb-3">
      <div class="text-subtitle-2 font-weight-bold">Типы услуг</div>
      <v-btn small text color="#483CB9" class="text-capitalize" @click="openCreate">
        <v-icon small left>mdi-plus</v-icon>
        Добавить
      </v-btn>
    </div>

    <v-btn-toggle v-model="activityFilter" mandatory dense class="calendar-activity-toggle mb-3">
      <v-btn small value="active">Активные</v-btn>
      <v-btn small value="inactive">Неактивные</v-btn>
      <v-btn small value="all">Все</v-btn>
    </v-btn-toggle>

    <div v-if="!serviceTypes.length" class="text-caption grey--text text-center py-4">
      Справочник пуст
    </div>
    <div v-else-if="!filteredServiceTypes.length" class="text-caption grey--text text-center py-4">
      Нет типов услуг, подходящих под выбранный фильтр
    </div>
    <v-simple-table v-else dense>
      <thead>
        <tr>
          <th class="text-caption grey--text">Код</th>
          <th class="text-caption grey--text">Название</th>
          <th class="text-caption grey--text text-right">Активность</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filteredServiceTypes" :key="item.id" :class="{ 'grey--text': item.is_active === false }">
          <td class="text-caption grey--text">{{ item.code }}</td>
          <td>
            {{ item.name }}
            <v-chip v-if="item.is_active === false" x-small color="grey lighten-2" class="ml-2">Неактивен</v-chip>
          </td>
          <td style="width: 116px;">
            <div class="d-flex align-center justify-space-between">
              <v-btn icon x-small @click="openEdit(item)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-switch
                :input-value="item.is_active !== false"
                dense
                hide-details
                inset
                class="calendar-switch--small ma-0 pa-0"
                @change="onToggleActive(item)"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-dialog v-model="dialog" max-width="360px">
      <v-card class="pa-2">
        <v-card-title class="text-subtitle-1 font-weight-bold">
          {{ editing ? 'Редактирование типа услуги' : 'Новый тип услуги' }}
        </v-card-title>
        <v-card-text>
          <div class="text-caption grey--text text--darken-1 mb-1">Код</div>
          <v-text-field v-model="form.code" outlined dense hide-details class="mb-4" />
          <div class="text-caption grey--text text--darken-1 mb-1">Название</div>
          <v-text-field v-model="form.name" outlined dense hide-details />
        </v-card-text>
        <v-card-actions>
          <v-btn block color="#483CB9" :dark="Boolean(form.code && form.name)" :loading="loading" :disabled="!form.code || !form.name" @click="save">
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
export default {
  name: 'ServiceTypesManager',
  props: {
    serviceTypes: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      editing: null,
      form: { code: '', name: '' },
      activityFilter: 'active', // active | inactive | all
    };
  },
  computed: {
    filteredServiceTypes() {
      return this.serviceTypes.filter((item) => {
        const isActive = item.is_active !== false;
        if (this.activityFilter === 'active') return isActive;
        if (this.activityFilter === 'inactive') return !isActive;
        return true;
      });
    },
  },
  methods: {
    openCreate() {
      this.editing = null;
      this.form = { code: '', name: '' };
      this.dialog = true;
    },
    openEdit(item) {
      this.editing = item;
      this.form = { code: item.code, name: item.name };
      this.dialog = true;
    },
    save() {
      if (!this.form.code || !this.form.name) return;
      if (this.editing) {
        this.$emit('save', { id: this.editing.id, ...this.form });
      } else {
        this.$emit('save', { ...this.form });
      }
      this.dialog = false;
    },
    onToggleActive(item) {
      this.$emit('toggle-active', { id: item.id, is_active: item.is_active === false });
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-switch--small {
  transform: scale(0.75);
  transform-origin: center;
}

.calendar-activity-toggle .v-btn {
  text-transform: none;
}
</style>
